// extracted by mini-css-extract-plugin
export default {"docItemContainer":"docItemContainer_Djhp","docItemCol":"docItemCol_VOVn"};